import pluralize from 'lib/pluralize'

export default (partnership: App.Partnership): string => {
  const bonusUnit = pluralize({ singular: partnership.bonusUnit, count: partnership.rewardEarn }).text
  return `${partnership.rewardEarn} ${partnership.rewardProgramName} ${bonusUnit} per ${partnership.rewardPer}`
}
